import { render, staticRenderFns } from "./ProductSale.vue?vue&type=template&id=ef60e698&"
import script from "./ProductSale.vue?vue&type=script&lang=js&"
export * from "./ProductSale.vue?vue&type=script&lang=js&"
import style0 from "./ProductSale.vue?vue&type=style&index=0&id=ef60e698&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports